import { InvoiceDetailPage } from "@/features/organization/invoice/pages/InvoiceDetail";

export const InvoiceDetail = () => {
  return <InvoiceDetailPage />;
};
